import { carouselItems } from '@/mocks/home';

const carouselImages: Record<string, string> = {
  'car-1': 'https://readdy.ai/api/search-image?query=Dramatic%20news%20editorial%20illustration%20with%20warm%20red%20and%20dark%20tones%2C%20abstract%20breaking%20news%20concept%2C%20bold%20graphic%20shapes%2C%20modern%20magazine%20layout%20style%2C%20high%20contrast%20dramatic%20lighting%2C%20professional%20journalism%20aesthetic&width=800&height=500&seq=car-1-51bl&orientation=landscape',
  'car-2': 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20megaphone%20with%20floating%20speech%20bubbles%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20bold%20geometric%20composition%2C%20modern%20news%20media%20design%2C%20dramatic%20shadows&width=800&height=500&seq=car-2-51bl&orientation=landscape',
  'car-3': 'https://readdy.ai/api/search-image?query=Dynamic%20newsroom%20style%20illustration%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20red%20alert%20accents%2C%20dark%20atmospheric%20background%2C%20professional%20journalism%20theme%2C%20high%20energy%20composition&width=800&height=500&seq=car-3-51bl&orientation=landscape',
  'car-4': 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20documents%20and%20digital%20data%20bursting%20out%2C%20corporate%20scandal%20theme%2C%20warm%20orange%20and%20deep%20red%20tones%2C%20dramatic%20lighting%2C%20editorial%20magazine%20style&width=800&height=500&seq=car-4-51bl&orientation=landscape',
  'car-5': 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20scenes%20artistic%20illustration%2C%20camera%20and%20spotlight%20motif%2C%20dramatic%20warm%20lighting%2C%20dark%20background%20with%20golden%20accents%2C%20cinematic%20editorial%20style%2C%20mysterious%20atmosphere&width=800&height=500&seq=car-5-51bl&orientation=landscape',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 mb-3">
            <i className="ri-flashlight-line text-primary-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-semibold text-primary-700">今日必看</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            焦点爆料
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            编辑部精选今日最重磅的爆料内容，不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 group cursor-pointer hover:scale-[1.01] transition-transform"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={carouselImages[item.id]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 rounded-full bg-black/50 text-white text-xs font-medium backdrop-blur-sm">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-bold text-foreground-900 text-base leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}

          {carouselItems.slice(3).map((item) => (
            <div
              key={item.id}
              className="sm:col-span-2 lg:col-span-2 bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 flex flex-col md:flex-row group cursor-pointer hover:scale-[1.01] transition-transform"
            >
              <div className="relative md:w-2/5 h-48 md:h-auto overflow-hidden">
                <img
                  src={carouselImages[item.id]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col justify-center">
                <span className="text-xs text-primary-600 font-semibold mb-2">{item.category}</span>
                <h3 className="font-bold text-foreground-900 text-lg leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}